/**
 * Power (W/kg) categories used across the whole platform — unified with the RMC race series.
 * Ordered from strongest to weakest.
 */
export const POWER_CATEGORIES = [
  { cat: 'ELITE', wkg: '≥ 4.7', min: 4.7 },
  { cat: 'A1', wkg: '≥ 4.4', min: 4.4 },
  { cat: 'A2', wkg: '≥ 4.1', min: 4.1 },
  { cat: 'A3', wkg: '≥ 3.8', min: 3.8 },
  { cat: 'A4', wkg: '≥ 3.5', min: 3.5 },
  { cat: 'A5', wkg: '≥ 3.2', min: 3.2 },
  { cat: 'A6', wkg: '≥ 2.9', min: 2.9 },
  { cat: 'A7', wkg: '≥ 2.6', min: 2.6 },
  { cat: 'A8', wkg: '≥ 2.3', min: 2.3 },
  { cat: 'A9', wkg: '< 2.3', min: 0 },
];

export function getPowerCategory(powerGroup) {
  if (!powerGroup) return null;
  const pg = parseFloat(powerGroup);
  if (Number.isNaN(pg)) return null;
  const found = POWER_CATEGORIES.find(c => pg >= c.min);
  return found ? found.cat : null;
}
